<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            <el-breadcrumb-item>卸料平台设备</el-breadcrumb-item>
            <el-breadcrumb-item>日志记录</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section" style="padding:0 1vw;">
            <el-page-header @back="goBack" :content="pageName" style="margin-right:1vw;"></el-page-header>
            <span style="margin-left:20px">时间：</span>
            <el-date-picker
              v-model="time"
              align="right"
              type="date"
              style="margin-right:20px"
              placeholder="选择日期"
              @change="doFilter"
              :picker-options="pickerOptions">
            </el-date-picker>
            <!-- <el-input style="margin-right:20px" placeholder="请输入设备序列号" v-model="dtuImei"></el-input>
            <el-button style="margin-right:20px" type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
            <el-button type="primary" @click="addRow()">绑定卸料平台设备</el-button> -->
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;" height="100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}"> 
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号">
                <template slot-scope="scope">
                  <span>{{ scope.row.index }}</span>
                </template>
              </el-table-column>
              <el-table-column label="设备名称">
                <template slot-scope="scope">
                  <a>{{ scope.row.unloadName}}</a>
                </template>
              </el-table-column>
              <el-table-column label="设备号">
                <template slot-scope="scope">
                  <a>{{ scope.row.verifyCode}}</a>
                </template>
              </el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <a v-if="scope.row.upstate=='0'" style="color:#67C23A;">正常</a>
                  <a v-else-if="scope.row.upstate=='1'" style="color:#E6A23C;">预警</a>
                  <a v-else-if="scope.row.upstate=='2'" style="color:#F56C6C;">报警</a>
                </template>
              </el-table-column>
              <el-table-column label="重量">
                <template slot-scope="scope">
                  <a>{{ scope.row.weight}}</a>
                </template>
              </el-table-column>
              <el-table-column label="电量百分比">
                <template slot-scope="scope">
                  <a>{{ scope.row.bias}}</a>
                </template>
              </el-table-column>
              <el-table-column label="偏置值">
                <template slot-scope="scope">
                  <a>{{ scope.row.electricQuantity}}</a>
                </template>
              </el-table-column>
              <el-table-column label="预警重量">
                <template slot-scope="scope">
                  <a style="color:#E6A23C;">{{ scope.row.earlyWarningWeight}}</a>
                </template>
              </el-table-column>
              <el-table-column label="报警重量">
                <template slot-scope="scope">
                  <a style="color:#F56C6C;">{{ scope.row.alarmWeight}}</a>
                </template>
              </el-table-column>
              <!-- <el-table-column label="所属项目">
                <template slot-scope="scope">
                  <span>{{ scope.row.projectName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="厂家">
                <template slot-scope="scope">
                  <span v-if="scope.row.equipType=='1'">携稳</span>
                </template>
              </el-table-column> -->
              <el-table-column label="时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.time }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[ 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      tableDataEnd: [], // 考勤机表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      groupId: util.session.get('groupId'),
      dataText: '数据加载中...',
      time:util.myTime.getCurTime(),
      verifyCode:'',
      pageName:'',
      id:''
    }
  },
  // watch: {
  //   groupId: {
  //     handler(newVal) {
  //       this.getData()
  //     },
  //     deep: true
  //   }
  // },
  mounted() {
    this.id = this.$route.params.id
    // this.getList()
    this.getData()
  },
  methods: {
    //获取信息
    getData(){
      var that = this
      myHttp.equipmentInformation({
        platformId:this.id
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var data = resp.data.data
          that.pageName = data.unloadName
          that.verifyCode = data.verifyCode
          that.getList()
        }
      })
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getList()
    },
    // 监控当前页码
    currentChangePage() {
      this.getList()
    },
    //
    doFilter(){
      this.currentPage = '1'
      this.getList()
    },

    //获取列表
    getList() {
      var option = {
        projectId: this.groupId,
        pageSize:this.pageSize,
        pageNum:this.currentPage,
        verifyCode:this.verifyCode,
        date:this.time
      }
      var that = this
      myHttp.equipUnloadLogList(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.pageInfo.total||0
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    // 编辑数据
    handleEdit(index, row) {
      // this.dialogTitle = '编辑设备信息'
      // this.addFormVisible = true
      // this.addForm={
      //   name:row.name,
      //   id:row.id,
      //   configurationId:row.configurationId,
      //   dtuImei:row.dtuImei,
      //   groupId:this.groupId
      // }
    },

    // 删除数据 111
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteEquipment({
            platformId: row.platformId,
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('删除成功')
            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      this.dialogTitle = '卸料设备绑定'
      this.addFormVisible = true
      this.addForm = {
         verifyCode:'',
         projectId:'',
         equipType:'1',
      }
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      // console.log(that.addForm)
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '' || !that.addForm.id) {
           that.addForm.projectId = that.groupId
           that.addForm.createBy =util.session.get('user').id
            //添加
            myHttp.addEquipment(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.currentPage = 1
                  that.getList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改 1111
           that.addForm.updateBy=util.session.get('user').id
            // myHttp.updateTsDtu(that.addForm).then(
            //   function(resp) {
            //     if (resp.data.code == '200') {
            //       that.$message.success('修改成功')
            //       that.addFormVisible = false
            //       that.getList()
            //     } else {
            //       that.$message.error(resp.data.msg)
            //     }
            //   },
            //   function() {}
            // )
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
    },
    //返回
    goBack(){
      this.$router.go(-1)
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    // doFilter(){
    //   this.getList()
    // }
  }
}
</script>
<style>
@import '../../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  /* justify-content: flex-end; */
  align-items: center;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  /* display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; */
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
</style>